module.exports = __webpack_public_path__ + "img/38.99700fd1.jpg";